export default __webpack_public_path__ + "static/media/BaseballBat_7.723a57c0.png";